"use client";

import React, { useEffect, useState } from "react";
import useCart from "@/cart/useCart";
import { useMediaQuery } from "@/hooks/useMediaQuery";

/**
 * RewardApplied pill that shows when a referral code is applied to the cart.
 * Detects discount codes starting with FRIEND-.
 */
function RewardApplied({ className = "mx-6" }) {
  const { cart, initializeCart } = useCart();
  const [isReferralApplied, setIsReferralApplied] = useState(false);
  const isBelow1000 = useMediaQuery("(max-width: 1200px)");

  useEffect(() => {
    initializeCart();
  }, [initializeCart]);

  useEffect(() => {
    const hasReferral = Boolean(
      cart?.discountCodes?.some(dc => dc?.code?.toUpperCase?.().startsWith("FRIEND-"))
    );
    setIsReferralApplied(hasReferral);
  }, [cart]);

  if (!isReferralApplied || isBelow1000) return null;

  return (
    <div
      className={`flex items-center bg-[#FFE895] border border-black rounded-full px-4 py-1 gap-2 cursor-pointer ${className}`}
      onClick={() => {
        try {
          window.dispatchEvent(new CustomEvent('open-custom-referral-popup'));
        } catch (error) {
          // no-op
        }
      }}
      title="View referral reward details"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          try {
            window.dispatchEvent(new CustomEvent('open-custom-referral-popup'));
          } catch (error) {
            // no-op
          }
        }
      }}
    >
      <img src="/images/Gift.svg" alt="Gift" className="w-3 h-3 mb-[1px]" />
      <p className="text-black text-sm font-medium font-trimMono">REWARD APPLIED!</p>
    </div>
  );
}

export default RewardApplied;

